"use client";

import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface ErrorFallbackProps {
  error?: Error;
  resetError?: () => void;
}

export function ErrorFallback({ error, resetError }: ErrorFallbackProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] p-8">
      <AlertTriangle className="h-12 w-12 text-red-500 mb-4" />
      <h1 className="text-2xl font-bold mb-2">Something went wrong</h1>
      <p className="text-gray-600 mb-6 text-center max-w-md">
        We apologize for the inconvenience. An error occurred while loading this page.
        {process.env.NODE_ENV === "development" && error && (
          <span className="block mt-2 text-sm font-mono text-red-600">
            {error.message}
          </span>
        )}
      </p>
      <div className="flex gap-4">
        <Button
          onClick={() => {
            if (resetError) {
              resetError();
            } else {
              window.location.reload();
            }
          }}
        >
          Try Again
        </Button>
        <Button
          variant="outline"
          onClick={() => {
            window.location.href = "/";
          }}
        >
          Go Home
        </Button>
      </div>
    </div>
  );
}